/* eslint-disable @ngrx/avoid-combining-selectors */
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Observable, of, combineLatest, BehaviorSubject } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { ConfigService } from 'src/app/plasma-ui-common/synlab-access-ui-components/core';
import { ConfigService as AppConfigService } from 'src/app/services/config/config.service';
import { Config } from 'src/app/plasma-ui-common/synlab-access-ui-components/model/config.model';
import { Store } from '@ngrx/store';
import { StsSelectors } from 'src/app/@store/selectors/sts.selectors';
import { STSActions } from 'src/app/@store/actions/sts.actions';
import { claimValues } from 'src/app/appsettings';

@Injectable({
  providedIn: 'root',
})
export class HeaderConfigService implements ConfigService {
  config: Config;
  configSubject: BehaviorSubject<Config>;
  config$: Observable<Config>;

  constructor(
    private cfg: AppConfigService,
    private store: Store,
  ) {
    this.setupConfig();
    const generateConfig = combineLatest([
      this.store.select(StsSelectors.isGenePlanetEnrolled),
      this.store.select(StsSelectors.hasGeneplanetOrders),
    ]).pipe(
      filter(([enrolled]) => enrolled !== null),
      map(([enrolled, canEnroll]) => enrolled || canEnroll),
      map(res => {
        if (this.cfg._envConfig.EnablePreventionWellness.toLowerCase() !== claimValues.TRUE) {
          return false;
        }
        return res;
      }),
      tap(res => {
        if (res === null) {
          this.store.dispatch(STSActions.fetchHasGeneplanetOrders());
        }
        return of(res);
      }),
      map(EnablePreventionWellness => ({
        ...this.config,
        EnablePreventionWellness,
      })),
      tap(config => this.configSubject.next(config)),
    );

    generateConfig.subscribe();
    this.config$ = this.configSubject.asObservable();
  }

  private setupConfig() {
    const {
      BaseAdminUrl,
      BaseBookingUrl,
      BaseBookingAdminUrl,
      BaseWebreqAdminUrl,
      BaseWebreqUrl,
      BasePlasmaUrl,
      BaseBigCommerceUrl,
      BaseProfileUrl,
      EeBaseBookingUrl,
      WhiteLabelEnabled,
      WhiteLabelName,
      EnableCheckResults,
      ResultsAndCertificateCustomLink,
    } = this.cfg._envConfig;

    this.config = {
      baseAdminUrl: BaseAdminUrl,
      baseBookingUrl: BaseBookingUrl,
      baseBookingAdminUrl: BaseBookingAdminUrl,
      baseWebreqAdminUrl: BaseWebreqAdminUrl,
      eeBaseBookingUrl: EeBaseBookingUrl,
      baseWebreqUrl: BaseWebreqUrl,
      basePlasmaUrl: BasePlasmaUrl,
      baseBigcommerceUrl: BaseBigCommerceUrl,
      baseProfileUrl: BaseProfileUrl,
      EnablePreventionWellness: null,
      FullCatalogueViewEnabled: true,
      applicationId: 'sts-accounts',
      WhiteLabelEnabled: WhiteLabelEnabled.toLowerCase() === 'true',
      WhiteLabelName,
      EnableCheckResults: EnableCheckResults?.toLowerCase() === 'true',
      ResultsAndCertificateCustomLink,
    };

    this.configSubject = new BehaviorSubject(this.config);
  }
}
